import { useDebugValue } from 'react';
import { useConditionValueFieldPath } from '../fieldPaths/useConditionValueFieldPath';
import { useFieldState } from '../../../contexts';

export const useConditionValueErrors = () => {
  const fieldPath = useConditionValueFieldPath();
  const { error } = useFieldState(fieldPath);
  useDebugValue(error);
  return error;
};
